import { createFileRoute } from '@tanstack/react-router';

import { FilteredPostsPage } from '@/features/(insight)/filtered-posts/ui/filtered-posts.page';
import {
  FILTERED_PAGE_END_DATE_KEY,
  FILTERED_PAGE_START_DATE_KEY,
} from '@/shared/hooks/use-filtered-page-date-range';
import z from 'zod';

const searchSchema = z.object({
  [FILTERED_PAGE_START_DATE_KEY]: z.string().optional(),
  [FILTERED_PAGE_END_DATE_KEY]: z.string().optional(),
});

export const Route = createFileRoute('/workspace/$workspaceId/insight/filtered-posts')({
  component: FilteredPostsPage,
  validateSearch: searchSchema,
});
